




















import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { IClaioImageSource } from "../../../../../../domain/claio";
import { IImageDragParameter } from "../../../../../dragging";
import { Size } from "../../../../../../domain/drawing";
import leftIcon from "@/assets/icon_left_jp.png";
import rightIcon from "@/assets/icon_right_jp.png";
import movieIcon from "@/assets/icon_movie.png";
import * as Moment from "moment";

@Component({
  components: {
  }
})
export default class ClaioImageThumbnail extends Mixins() {
  data(): any {
    return {
      imageWidthText: null,
      imageHeightText: null,
    };
  }
  imageWidthText: string;
  imageHeightText: string;

  @Prop()
  size: Size;

  @Prop()
  claioImageSource: IClaioImageSource;

  @Prop()
  isFocused: boolean;

  get rootStyleProperties(): any {
    return {
      width: this.size.width + "px",
      height: this.size.height + "px",
      outline: this.isFocused ? "2px solid rgba(255, 0, 0, 0.5)" : "none",
    };
  }

  get thumbnailImageStyleProperties(): any {
    return {
      position: "absolute",
      maxWidth: this.size.width + "px",
      maxHeight: this.size.height + "px",
    };
  }

  get thumbnailImageSource(): string {
    return this.claioImageSource.thumbnailSource;
  }

  get isLeftImage(): boolean {
    return this.claioImageSource.isLeft;
  }

  get leftIconImageSource() {
    return leftIcon;
  }

  get isRightImage(): boolean {
    return this.claioImageSource.isRight;
  }

  get rightIconImageSource() {
    return rightIcon;
  }

  get isMovieImage(): boolean {
    return this.claioImageSource.isMovie;
  }

  get movieIconImageSource() {
    return movieIcon;
  }

  get description(): string {
    // TODO: 時刻・登録診療科も見れたほうがよい？
    if (this.claioImageSource.imageDate) {
      const moment = Moment(this.claioImageSource.imageDate);
      return moment.format("YYYY/MM/DD");
    }
  }

  adjustImageSize(): void {
    const image = this.$refs.image as HTMLImageElement;
    if (!image) { return; }
    // 比率が大きい方に合わせる
    const ratioWidth = image.naturalWidth / this.size.width;
    const ratioHeight = image.naturalHeight / this.size.height;
    this.imageWidthText = (ratioWidth >= ratioHeight) ? "100%" : null;
    this.imageHeightText = (ratioWidth <= ratioHeight) ? "100%" : null;
  }

  onDragStart(event: DragEvent): void {
    const data: IImageDragParameter = {
      isClaioImage: true,
      claioImageDragParameter: {
        patientId: this.claioImageSource.patientId,
        claioImageId: this.claioImageSource.claioImageKey,
        isVisibleLayer: !!this.claioImageSource.isVisibleLayer,
        isMovie: !!this.claioImageSource.isMovie,
        isSecret: !!this.claioImageSource.isSecret,
        imageDepartmentId: this.claioImageSource.departmentId,
      }
    };
    const text = JSON.stringify(data);
    // 第一引数(format)が"text"でないとIEでエラーになる。
    event.dataTransfer.setData("text", text);
  }

  onThumbnailSelected(event: PointerEvent): void {
    this.selected(this.claioImageSource);
  }

  @Emit()
  selected(src: IClaioImageSource): void {}

  onThumbnailDoubleClicked(): void {
    this.doubleClick(this.claioImageSource);
  }

  @Emit()
  doubleClick(src: IClaioImageSource): void {}
}
